import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Shelf, Text, Button } from 'chaser-components';
import config from '../../../../config/index';

class InviteClients extends React.Component {
  constructor() {
    super();

    this.state = {
      clientsModalOpen: false,
      accountingSoftware: '',
    };
  }

  handleSelect = e => {
    this.setState({
      accountingSoftware: e,
    });
  };

  handleSubmit = () => {
    const { bundle, userId } = this.props;

    window.open(`${config.webAppUrl}/connect/${userId}/${bundle}`);
  };

  render() {
    const { error } = this.props;
    if (error) return;

    return (
      <Shelf style={{ marginTop: '21px' }}>
        <Shelf justifyContent="center">
          <Text color="Mid Neutral 1">
            Note: Additional licences on top of your partner bundle are only
            billed when they start chasing
          </Text>
          <Button
            data-testid="invite-modal-btn"
            onClick={this.handleSubmit}
            iconRight="external">
            Add client
          </Button>
        </Shelf>
      </Shelf>
    );
  }
}

const mapStateToProps = ({ loginReducer, clientsReducer }) => ({
  error: clientsReducer.error,
  userId: loginReducer.userId,
  bundle: loginReducer.bundle,
});

export default connect(mapStateToProps)(InviteClients);

InviteClients.propTypes = {
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  bundle: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

InviteClients.defaultProps = {
  error: undefined,
};
